import { createSelector } from 'reselect';

const getReportsState = (state) => state.reports;

export const reportsSelector = createSelector([getReportsState], (state) => {
  const { isLoading, isLoadingPageConfig, users, viewTabs, mainConfig, pageData, pageConfig, pageFilterType, pageFilters, pageFiltersQuery, pageFiltersQueryKey } = state;

  return {
    isLoading,
    isLoadingPageConfig,
    users,
    viewTabs,
    mainConfig,
    pageData,
    pageConfig,
    pageFilters,
    pageFilterType,
    pageFiltersQuery,
    pageFiltersQueryKey,
  };
});
